import { gql } from '@apollo/client'

export const ImportStatusChangeSubscription = gql`
    subscription onImportFileExtractionStatusChange($instanceId: String!) {
        onImportFileExtractionStatusChange(instanceId: $instanceId) {
            firmId
            projectId
            status
            fileInfo {
                fileKey
                title
                parentAssemblyTreePaths
                productTypeCount
                productTypeInfo {
                    name
                    propertiesCount
                    textType
                }
                propertiesCount
                errors
                warnings
                familyId
                backConvertedDiffDocxUri
            }
            errorMessage
            instanceId
        }
    }
`
export const DuplicateFIleStatusChangeSubscription = gql`
    subscription onImportDuplicateFamilyStatusChange($instanceId: String!) {
        onImportDuplicateFamilyStatusChange(instanceId: $instanceId) {
            firmId
            projectId
            duplicateFamilies {
                fileKey
                familyId
            }
            userImportedFamilies {
                fileKey
                familyId
            }
            errorMessage
            instanceId
        }
    }
`
export const getChildQuery = (depth: number): string => {
    if (depth === 0) return ''
    return `
    children {
                        index
                        type
        ${getChildQuery(depth - 1)}
         content {
                        id
                        type
                        text
                        imperialUnits
                        metricUnits
                        hyperlinkUrl
                        optionItemState
                        elements {
                            id
                            type
                            text
                            imperialUnits
                            metricUnits
                            hyperlinkUrl
                            optionItemState
                            elements {
                                id
                                type
                                text
                                imperialUnits
                                metricUnits
                                hyperlinkUrl
                                optionItemState
                                elements {
                                    id
                                    type
                                    text
                                    imperialUnits
                                    metricUnits
                                    hyperlinkUrl
                                    optionItemState
                                }
                            }
                        }
                    }
                    hierarchicalLevel
               
    }
    `
}
export const GetPreviewSubscription = () => {
    const elements = getChildQuery(6)
    return gql`
    subscription onImportedFilePreviewStatusChange(
        $instanceId: String!
    ) {
        onImportedFilePreviewStatusChange(instanceId: $instanceId) {
            fileName
            fileKey
            instanceId
            errorMessage
            status
            sectionPreview{
                sectionNumber
                sectionName
                prefix
                title
                documentDetails {
                    lastModified
                    author
                }
                paragraphs {
                    index
                    type
                    ${elements}
                    content {
                        id
                        type
                        text
                        imperialUnits
                        metricUnits
                        hyperlinkUrl
                        optionItemState
                        elements {
                            id
                            type
                            text
                            imperialUnits
                            metricUnits
                            hyperlinkUrl
                            optionItemState
                            elements {
                                id
                                type
                                text
                                imperialUnits
                                metricUnits
                                hyperlinkUrl
                                optionItemState
                                elements {
                                    id
                                    type
                                    text
                                    imperialUnits
                                    metricUnits
                                    hyperlinkUrl
                                    optionItemState
                                }
                            }
                        }
                    }
                    hierarchicalLevel
                    
                }
            }
        }
    }
`
}
export const ExecuteProjectImportResultChange = gql`
    subscription onExecuteProjectImportResultChange($instanceId: String!) {
        onExecuteProjectImportResultChange(instanceId: $instanceId) {
            firmId
            projectId
            status
            importResult {
                fileName
                productFamilyId
                productFamilyIdGuid
                status
            }
            errorMessage
            importInstanceId
        }
    }
`
